import { Component } from '@angular/core';
import { ApiService } from '../../../services/api.service';

import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-login',
  imports: [FormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  email = '';
  password = '';
  loading = false;
  error: string | null = null;

  constructor(
    private api: ApiService,
    private auth: AuthService,
    private router: Router
  ) {}

  onLoginClick(): void {
    this.loading = true;
    this.error = null;
    const body = { email: this.email, password: this.password };
    this.api.post<any>('/auth/login', body).subscribe({
      next: (data) => {
        // expect { token: '...' } or similar
        const token = data?.token ?? (data as any);
        if (token) {
          this.auth.setToken(token);
          this.router.navigate(['/admin/dashboard']);
        } else {
          this.error = 'Invalid login response';
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Login failed', err);
        this.error = err?.error?.message ?? 'Login failed';
        this.loading = false;
      },
    });
  }
}
